import React, { Fragment } from 'react';
import ReactDOM from 'react-dom';
import HmEventRegistry from '../../model/HmEventRegistry';
import LoggedInPage from '../core/LoggedInPage';
import ViewSolutionLayout from '../contest/viewsolution/ViewSolutionLayout';

export default class ViewSolutionWindow extends LoggedInPage{
    constructor(props){
        super(props);
    }

    callBackParent = () => {
        var subRoot = document.getElementById('subroot');
        ReactDOM.unmountComponentAtNode(subRoot);
    }

    getSolutionLayout = () => {
        let solutionData = (this.props.solutionData) ?  this.props.solutionData : null;
        if(solutionData){
            //console.warn("ViewSolutionWindow ",solutionData)
            return(
			    <ViewSolutionLayout callBackParent={this.callBackParent} data={solutionData}></ViewSolutionLayout>
			);
		}
    }

	render(){
        return(
            <Fragment>
                {this.getSolutionLayout()}
            </Fragment>
        )
    }
}

	HmEventRegistry.registerEvent("SHOW_SOLUTION",function(obj){
		ReactDOM.render(<ViewSolutionWindow solutionData={obj}/>, document.getElementById('subroot'));	
	});



// WEBPACK FOOTER //
// ./src/views/common/ViewSolutionWindow.js